import { Component, Input, OnInit } from '@angular/core';

import { NbMenuService, NbSidebarService, NbMenuItem } from '@nebular/theme';
import { UserService } from '../../../@core/data/users.service';
import { AnalyticsService } from '../../../@core/utils/analytics.service';
import { AuthService } from '../../../services/auth.service';
import { Notificacao } from '../../../pages/notificacoes/notificacao';
import { NotificacaoService } from '../../../services/notificacao/notificacao.service';
import { Router } from '@angular/router';

@Component({
    selector: 'ngx-header',
    styleUrls: ['./header.component.scss'],
    templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {

    @Input() position = 'normal';

    user: any;
    notificacoesMenu = [{
        title: "Ver Todas",
        link: "notificacoes"
    }];
    notificacoesCount = 0;
    userMenu = [
        { title: 'Meus Dados' },
        {
            title: 'Logout',
            target: "#logout-trigger"
        }
    ];
    balaoNotificacaoStyle = {};
    logout() {
        this.auth.logout();
    }

    navegarNotificacoes(){
        this.router.navigate(['pages', 'notificacoes']);
    }

    constructor(private notificacoesService: NotificacaoService, private sidebarService: NbSidebarService,
        private menuService: NbMenuService,
        private router: Router,
        private analyticsService: AnalyticsService, private auth: AuthService) {
            setInterval((()=>{
                if(this.auth.isLoggedIn())
                    this.carregarNotificacoes();
            }),7000);
    }

    ngOnInit() {
        this.carregarNotificacoes();
    }

    carregarNotificacoes() {
        this.notificacoesService.QuantidadePorUsuario().subscribe(data => {
            this.notificacoesCount =  data["Retorno"];

        });
    }
    toggleSidebar(): boolean {
        this.sidebarService.toggle(true, 'menu-sidebar');
        return false;
    }

    toggleSettings(): boolean {
        this.sidebarService.toggle(false, 'settings-sidebar');
        return false;
    }

    goToHome() {
        this.menuService.navigateHome();
    }

    startSearch() {
        this.analyticsService.trackEvent('startSearch');
    }
}



// WEBPACK FOOTER //
// ./src/app/@theme/components/header/header.component.ts